import { Route, Switch } from "react-router-dom";
import AreaComumImagensPage from "./Imagens";
import AreaComumListagemPage from "./Listagem";
import AreaComumDetalhesPage from "./Detalhes";
import AreaComumBloqueioUnidadePage from "./BloqueioUnidade";

function AreaComumPages() {
  return (
    <Switch>
      <Route
        exact
        path="/cadastros/areas-comum"
        component={AreaComumListagemPage}
      />
      <Route
        exact
        path="/cadastros/areas-comum/bloqueio"
        component={AreaComumBloqueioUnidadePage}
      />
      <Route
        exact
        path="/cadastros/areas-comum/new"
        component={AreaComumDetalhesPage}
      />
      <Route
        exact
        path="/cadastros/areas-comum/:id"
        component={AreaComumDetalhesPage}
      />
      <Route
        exact
        path="/cadastros/areas-comum/:id/imagens"
        component={AreaComumImagensPage}
      />
    </Switch>
  );
}

export default AreaComumPages;
